module.exports = __webpack_public_path__ + "media/application/images/svgs/pie-chart-3fb024dd069d9d6668b2837a4be12873.svg";